import React from 'react';
import {ajax, resolveRoute} from '../../helpers/ajax'
import YearControl from './YearControl';
import type {InsightData} from "./InsightsTotalsRow";
import InsightsTotalsRow from "./InsightsTotalsRow";

interface InsightsTotalsDataState {
    data: InsightData
}

interface Props {
    year: number
    changeYear: AnyFn
}

export default class InsightsTotalsData extends React.PureComponent<Props, InsightsTotalsDataState> {

    state = {data: {}};

    componentDidMount() {
        this.refresh();
    }

    refresh = () => {
        const timer = setTimeout(() => {
            this.setState({data: {}});
        }, 800);
        ajax(resolveRoute('reports.insights.totals')!, {
            queryParams: {
                year: this.props.year
            }
        }).then((res: any) => {
            if (res.ok) {
                clearTimeout(timer);
                this.setState({data: res.data});
            }
        });
    }

    componentDidUpdate(prevProps: any, prevState: any) {
        if (prevProps.year !== this.props.year) {
            this.refresh();
        }
    }

    render() {
        const {data} = this.state;

        return (
            <div>
                <YearControl changeYear={this.props.changeYear} year={this.props.year}/>
                <InsightsTotalsRow {...data}/>
            </div>
        )
    }
}
